import {apiClient} from '../client'

export const fetchElements = async () => {
  const {elements} = await apiClient.get('elements')
  return elements
}
